import { cn } from "@/lib/utils";

export const inputStyle = (prefix = false, clearable = false, className?: string) => cn(
  "flex w-full rounded border border-neutral-500 bg-neutral-600 px-3 py-2 text-base ring-offset-neutral-500 placeholder:text-neutral-450 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  prefix ? "pl-8" : "pl-3",
  clearable ? "pr-9" : "pr-3",
  className,
);
